import { DEEPLINK_SCHEME } from './DEEPLINK_SCHEME';
export const resolveDeepLink = (link) => {
    const parts = link.replace(DEEPLINK_SCHEME, '').split('/');
    if (parts[0] === 'discover') {
        parts[0] = '';
    }
    let route = '';
    switch (parts[0]) {
        case '':
        case 'search':
        case 'login':
        case 'account':
            route = parts.join('/');
            break;
        case 'library':
            if (parts[1] === 'downloads' || parts.length < 3) {
                route = 'library';
            }
            else {
                route = parts.join('/');
            }
            break;
    }
    return route;
};
//# sourceMappingURL=resolveDeepLink.js.map